import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { UserAuthorityChoice } from "utils/common";
import { deleteToken, useAppContext } from "utils/store";

export default function DbmsLayout({ children }) {
  const navigate = useNavigate();
  const {
    store: { userAuthority, userName },
    dispatch,
  } = useAppContext();
  const location = useLocation();
  const links = [
    { path: "/dbms/fire-receiver/management", text: "화재수신기 관리" },
    { path: "/dbms/fire-receiver/settings", text: "화재수신기 설정", userAuthority: UserAuthorityChoice.ADMIN },
    { path: "/dbms/logs/status", text: "상태 Status 수신 로그" },
    { path: "/dbms/logs/data-transmission", text: "제어 Data 전송 로그" },
    { path: "/dbms/business/management", text: "사업자 관리", userAuthority: UserAuthorityChoice.ADMIN },
    { path: "/dbms/business/accounts", text: "사업자 계정관리", userAuthority: UserAuthorityChoice.ADMIN },
    { path: "/dbms/users/accounts", text: "사용자 계정관리" },
    { path: "/dbms/fire-protection/targets", text: "소방대상물 관리" },
    { path: "/dbms/notices/management", text: "공지사항 관리", userAuthority: UserAuthorityChoice.ADMIN },
    { path: "/dbms/external-api/integration", text: "외부 API 연동 관리", userAuthority: UserAuthorityChoice.ADMIN },
    {
      path: "/dbms/external-api/transmission-logs",
      text: "외부 API 전송 로그",
      userAuthority: UserAuthorityChoice.ADMIN
    },
    { path: "/dbms/system/monitoring", text: "시스템 이용현황 모니터링", userAuthority: UserAuthorityChoice.ADMIN },
    { path: "/dbms/fire-equipment/mdb", text: "소방설비 MDB", userAuthority: UserAuthorityChoice.ADMIN },
    { path: "/dbms/fire-receiver/mdb", text: "화재수신기 MDB", userAuthority: UserAuthorityChoice.ADMIN },
  ];

  const getClassName = (path) => {
    return `item_dept ${location.pathname.startsWith(path) ? "now" : ""}`;
  };

  const handleSetting = () => {
    navigate("/user-account/");
  };

  const handleLogout = () => {
    if (window.confirm("로그아웃하시겠습니까?")) {
      dispatch(deleteToken());
      navigate("/");
    }
  };

  return (
    <>
      <div class="wrap_dept">
        <div class="top_dept">
          <p class="user">{userName}</p>
          <div class="wrap_contr">
            <button class="set_contr" onClick={() => navigate("/")}>
              <i class="x-icon"></i>
            </button>
            <button class="set_contr" onClick={handleSetting}>
              <i class="x-icon"></i>
            </button>
            <button class="set_contr" onClick={handleLogout}>
              <i class="x-icon"></i>
            </button>
          </div>
        </div>
        <div class="divi"></div>
        <div class="btm_dept">
          <p class="title_dept">시스템 DBMS</p>
          <div class="nav_dept">
            {links.map((link) =>
              typeof link.userAuthority === "undefined" ||
                (link.userAuthority && link.userAuthority === userAuthority) ? (
                <Link
                  key={link.path}
                  className={getClassName(link.path)}
                  to={link.path}
                >
                  {link.text}
                </Link>
              ) : null
            )}
          </div>
        </div>
      </div>
      {children}
    </>
  );
}
